module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/dev-stack.json
// module id = 402
// module chunks = 226396459170509